import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { ActivateIcon, AlertIcon } from 'assets/materialIcons/materialIcons';
import { connect } from 'react-redux';

class DeleteAction extends React.Component {
    state = {
        dialog: false,
    };

    handleDialogOpen = () => {
        this.setState({
            dialog: true,
        });
    };

    handleDialogClose = () => {
        this.setState({
            dialog: false,
        });
    };

    handleDialogSubmit = () => {
        const { action, dispatch, record, params } = this.props;

        let data = {
            id: record.id,
            ...params,
        };

        /**
         * This will trigger a specific action, which is defined in the upper level.
         * This action can only be a function, and will always pass the id of the record.
         */
        dispatch(action(data));

        this.handleDialogClose();
    }

    render() {
        const { description, record, title, optionTitle, translate } = this.props;

        if (!record) {
            return null;
        }

        const actions = [
            <RaisedButton
                icon={ <AlertIcon /> }
                key='cancel'
                keyboardFocused={ true }
                label={ translate('actions.cancel') }
                onTouchTap={ this.handleDialogClose }
                style={ { marginRight: '20px' } }
            />,
            <RaisedButton
                icon={ <ActivateIcon /> }
                key='submit'
                label={ translate('actions.ok') }
                onTouchTap={ this.handleDialogSubmit }
                primary
            />,
        ];

        return (
            <div>
                <MenuItem
                    onTouchTap={ this.handleDialogOpen }
                    primaryText={ optionTitle ? translate(optionTitle) : translate('actions.delete') }
                />

                <Dialog
                    actions={ actions }
                    actionsContainerStyle={ { padding: '0 24px 24px' } }
                    contentStyle={ { maxWidth: '600px' } }
                    modal={ false }
                    onRequestClose={ this.handleDialogClose }
                    overlayStyle={ {
                        backgroundColor: 'rgba(237, 236, 236, 0.6)',
                    } }
                    open={ this.state.dialog }
                    title={ translate(title) }
                >
                    { translate(description) }
                </Dialog>
            </div>
        );
    }
}

DeleteAction.defaultProps = {
    description: 'elements.delete.description',
    title: 'elements.delete.title',
    params: {},
};

DeleteAction.propTypes = {
    action: PropTypes.func.isRequired,
    description: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    params: PropTypes.object,
    title: PropTypes.string.isRequired,
    optionTitle: PropTypes.string,
    record: PropTypes.object,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    connect(),
    translate,
);

export default enhance(DeleteAction);



// WEBPACK FOOTER //
// ./src/components/field/DropDownActionsMenu/DeleteAction.js